import request from '../http/axios'

export default {
  // get请求
  getData(url, data) {
    return request.get(url, { params: data })
		},
		// post请求
  postData(url, data) {
    return request.post(url, data)
		},
		// put请求
  putData(url, data) {
    return request.put(url, data)
		},
		// delete请求
  deleteData(url, data) {
    return request.delete(url, data)
  }
	} 
 

